// extracted by mini-css-extract-plugin
export default {"list":"FrontTaskCardList_list__8LdoC","modalClose":"FrontTaskCardList_modalClose__I+vhC","modal":"FrontTaskCardList_modal__fh92y"};